import {WixSdk} from '@wix/js-sdk-wrapper';

export function isStandalone() {
  return WixSdk.Utils.getViewMode() === 'standalone';
}
